import { formatMoney } from "./money";

const hiddenModes = new Set(["hidden", "hide", "none"]);

export const resolvePromotionBadge = ({
  quote,
  settings = {},
  language = "english",
  label,
} = {}) => {
  if (!quote || !quote.isDiscounted) return null;
  if (
    settings.hide_discount_tag === true ||
    settings.hide_product_discount_tag === true ||
    settings.show_discount_tag === false
  ) {
    return null;
  }

  const promotion = quote.promotion || {};
  if (promotion.hidden === true || promotion.hide_badge === true) return null;
  if (label) return { mode: "label", text: label, color: promotion.color };
  const pricedPromotionLabel =
    language === "arabic"
      ? promotion.label_ar || promotion.name_ar || promotion.label || promotion.name
      : promotion.label || promotion.name;
  if (pricedPromotionLabel) {
    return {
      mode: promotion.mode || promotion.type || "label",
      text: pricedPromotionLabel,
      color: promotion.color || promotion.badge_color,
    };
  }
  const customLabel =
    language === "arabic"
      ? settings.promotion_badge_label_ar || settings.promotion_badge_label
      : settings.promotion_badge_label_en || settings.promotion_badge_label;
  if (customLabel) return { mode: "label", text: customLabel };

  const mode = String(
    promotion.mode ||
      promotion.type ||
      settings.promotion_badge_mode ||
      settings.discount_tag_mode ||
      "percent",
  ).toLowerCase();
  if (hiddenModes.has(mode)) return null;

  if (mode === "fixed") {
    return {
      mode,
      text: `-${formatMoney(quote.discountAmount, {
        settings: { ...settings, currency_decimals: quote.decimals },
        language,
        currency: quote.currency,
      })}`,
      color: promotion.color || promotion.badge_color,
    };
  }
  if (mode === "label") {
    return null;
  }
  return {
    mode: "percent",
    text: `${quote.discountPercent}%`,
    color: promotion.color || promotion.badge_color,
  };
};
